export function normalizeRoleKey(role: string | null | undefined): string {
  return String(role ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "");
}

export function isSysadminRole(role: string | null | undefined): boolean {
  const k = normalizeRoleKey(role);
  return k === "sysadmin" || k === "syadmin";
}
